import { z } from 'zod';
import { templateNamedWidgetSchema } from './base';
import { fieldLayoutShape } from './field-layout';

export const templateClinicalSignatureSchema = templateNamedWidgetSchema.extend(
  {
    type: z.literal('clinicalSignature'),
    isRequired: z.boolean(),
    ...fieldLayoutShape,
    /**
     * 簽名圖片（PNG base64 data URL），未簽名時為空字串。
     */
    value: z.string(),
  },
);

export type TemplateClinicalSignatureV1 = z.infer<
  typeof templateClinicalSignatureSchema
>;
